import { render } from "./User-bank.vue?vue&type=template&id=47ad283d"
import script from "./User-bank.vue?vue&type=script&lang=js"
export * from "./User-bank.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__